document.addEventListener('DOMContentLoaded', () => {

  const emailInput = document.getElementById('ContactForm-email');
  const emailError = document.getElementById('email-error');
  const messageInput = document.getElementById('ContactForm-body');
  const messageError = document.getElementById('message-error');
  const submitButton = document.getElementById('contact-form-submit');

  emailInput.addEventListener('focus', validateForm);
  emailInput.addEventListener('input', validateForm);
  messageInput.addEventListener('focus', validateForm);
  messageInput.addEventListener('input', validateForm);

  function validateForm() {
    const emailValue = emailInput.value.trim();
    const messageValue = messageInput.value.trim();

    let isFormValid = true;

    if (emailValue === '' || !isValidEmail(emailValue)) {
      emailError.textContent = 'Wprowadź poprawny email';
      emailInput.classList.add('error-border');
      isFormValid = false;
    } else {
      emailError.textContent = '';
      emailInput.classList.remove('error-border');
    }

    if (messageValue === '') {
      messageError.textContent = 'Wiadomość nie może być pusta';
      messageInput.classList.add('error-border');
      isFormValid = false;
    } else {
      messageError.textContent = '';
      messageInput.classList.remove('error-border');
    }

    submitButton.disabled = !isFormValid;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }
});
